
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './BabyPhotoContest.css';
import * as actions from './Actions';
import { fetchInitialData } from "../fetchData";
import Right from '../right/Right';
import Service from '../service/Service';
import withLocation from "../../withLocation";
const service = new Service();

class ContestDetails extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let winnersContest = [];
        let imageUrl='';
        let metaurl='';
        // if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
        //     initialData = window.__initialData__['initialData'];
        //     console.log('initialData >>>> : ',initialData);
        //     imageUrl=initialData['result'][0]['banners'][0]['bannerUrl'];

        //     delete window.__initialData__;

        // } else {
        //     if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
        //         initialData = props.staticContext.initialData['initialData'];
        //         console.log('initialData else >>>> : ',initialData);
        //         imageUrl=props.staticContext.initialData['initialData']['result'][0]['banners'][0]['bannerUrl'];
        //     }
        // }
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            console.log('window.__initialData__ : ', window.__initialData__);
            initialData = window.__initialData__.initialData?.result;
            console.log('initialData (browser) >>>> :', initialData);
            delete window.__initialData__; // clean up after usage
        } else if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
            console.log("props.staticContext.initialData:", props.staticContext.initialData);
            initialData = props.staticContext.initialData.initialData?.result;
            console.log('initialData (server) >>>> :', initialData);
        }
        
        // Safely extract imageUrl
        imageUrl = initialData?.result?.[0]?.banners?.[0]?.bannerUrl || null;


        this.state = {
            initialData: initialData,
            metaTitle: "Memories Contest",
            imageUrl:imageUrl,
            metaurl:metaurl,
            // metaDescription: [
            //     { "name": "description", "content": "Memories Contest - FirstCry Parenting" }
            // ]
            metaDescription: "Memories Contest - FirstCry Parenting" 
        }
        // alert('inside constructor');
    }
    static initialAction(reqUrl, ftk, authData, uId, childData) {    
            // alert('init'); 
        var header = {
            'Content-Type': 'application/json',
            'ftk':  ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var ConDetailUrl = reqUrl.split('/')[4];
        if(ConDetailUrl.includes('?')){
            ConDetailUrl = ConDetailUrl.split('?')[0];
            // console.log('?????? In URL')
        }
        // console.log('ConDetailUrl details page >>>>>> : ',ConDetailUrl);
        if(ConDetailUrl != 'sizzle.min.map'){
            var url = global.api_url + "contest/getcontestdetails";
            let body = JSON.stringify({ 
                        "pageNo": 1,
                        "pageSize": 10 ,
                        "contestId": ConDetailUrl      
                    })
            return fetchInitialData(url, JSON.stringify(header), body);
        }
    }

    detailsAPICall(){
        var ConDetailUrl = this.props.location.pathname.split('/');
        var dUlr = ConDetailUrl[4] ? ConDetailUrl[4] : '';
        var postData = {
            "pageNo": 1,
            "pageSize": 10 ,
            "contestId": dUlr 
        }
        var url = global.api_url + "contest/getcontestdetails";
        service.postServiceCall(url, postData).then((json) => {
            // console.log('details 2 call datd: ', json);
            if (json){
                this.setState({ initialData: json}, () => { 
                });
            }
            service.hideLoader();
            
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    componentDidMount() {
        if(navigator.onLine) {
            var ContestName;
            var btnLable = 'UPLOAD PHOTO';
            var leaderboardbtn = "VIEW ENTRIES";
            var leaderboardurl = "entries";

            // console.log('Details page initialData',this.state.initialData);

            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {

                service.showLoader();
                // this.detailsAPICall();
            } else {
                localStorage.setItem('contestDetails', JSON.stringify(this.state.initialData));
            }
        
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
                // this.detailsAPICall();
            } else {
                localStorage.setItem('contestDetails', JSON.stringify(this.state.initialData));
            }
            
            this.leaderboardAPICall(); 
            for(var i=0; i<this.state.initialData.length; i++){
                if(this.state.initialData[i].isWinnerbased){
                leaderboardbtn = "VIEW LEADERBOARD";
                leaderboardurl = "leaderboard";
                this.setState({ leaderboardbtn: leaderboardbtn });
                this.setState({ leaderboardurl: leaderboardurl });
                }
            }
            document.addEventListener("click", this.domClick);
        }else{
            service.showAlert("Please Check Internet Connection!!!");
        } 
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.domClick);
    }
     
    leaderboardAPICall(){
        if(navigator.onLine) {
            var ContestName;
            var ConDetailUrl = this.props.location.pathname.split('/');
            var dUlr = ConDetailUrl[4];
            var postData = {
                "pageNo": 1,
                "pageSize": 10,
                "contestId": dUlr
            }
            // console.log('details leader postData: ', postData);
            // var url = global.api_url + "contest/getleaderboard";
            var url = global.api_ci_url + "MemoriesContest/leaderboardajax";
            service.postServiceCall(url, postData).then((json) => {
                // console.log('details leader json: ', json);
                if (json['result']) {
                    this.setState({ leatherDetails: json['result'] }, () => { 
                    });
                }
                
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        }else{
            service.showAlert("Please Check Internet Connection!!!");
        }
    }

    domClick(event) {
        if (!event.target.classList.contains('share-ic') && !event.target.classList.contains('whtap-icon') && !event.target.classList.contains('left')) {            
            if (document.getElementsByClassName('sharing-options')[0]) {
                document.getElementsByClassName('sharing-options')[0].style.display = 'none';
            }
        }
        
        if (event.target.classList.contains('next')) {
            if (document.getElementsByClassName('next')[0]) {
                document.getElementsByClassName('next')[0].style.display = 'none';
            }else{
                document.getElementsByClassName('next')[0].style.display = 'block'; 
            }
        }        
    }

    shareArticle(articleurl, shareoption, image, title) {
        if(navigator.onLine) {
            this.setState({ metaurl: articleurl });
            this.setState({ metaimg: image });
            this.setState({ metatitle: title });

            var shareurl;
            let ary = document.getElementsByClassName('sharing-options');
            for (let i = 0; i < ary.length; i++) {
                ary[i].style.display = 'none';
            }
            if (document.getElementsByClassName('share-overlay')[0]) {
                document.getElementsByClassName('share-overlay')[0].style.display = 'none';
            }
            if (shareoption == "facebook") {
                shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
            } else if (shareoption == "twitter") {
                shareurl = 'https://twitter.com/share?url=';
            } else if (shareoption == "pintrest") {
                shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
            } else if (shareoption == "whatsapp") {
                shareurl = 'whatsapp://send?text=';
            }
            var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
            if (sharewindow.focus) {
                sharewindow.focus();
            }
            return false;
        }else{
            service.showAlert("Please Check Internet Connection!!!");
        }
    }

    render() {  
        console.log("this.state.initialData ===>",this.state.initialData)  

        // console.log("this.state.initialData.result[0] ===>",this.state.initialData.result[0])  
        return (
            <main className="main-container">
                <Helmet
                    title={this.state.metaTitle}
                    // meta={this.state.metaDescription}

                    meta={[
                        {"name": "description", "content":this.state.metaDescription},
                        // this.state.metaDescription,
                        // <!-- Google / Search Engine Tags -->
                        { "itemprop": "name", "content": "PARENTING.FIRSTCRY.COM" },
                        { "itemprop": "description", "content":  this.state.initialData && this.state.initialData['description'] ? this.state.initialData['description'] : this.state.metaDescription },
                        { "itemprop": "image", "content": this.state.imageUrl },
                        // <!-- Facebook Meta Tags -->
                        { "property": "og:url", "content": global.currentURL },
                        { "property": "og:type", "content": "website" },
                        { "property": "og:title", "content": this.state.initialData && this.state.initialData['title'] ? this.state.initialData['title'] : "PARENTING.FIRSTCRY.COM" },
                        { "property": "og:description", "content":  this.state.initialData && this.state.initialData['description'] ? this.state.initialData['description'] : this.state.metaDescription },
                        { "property": "og:image", "content": this.state.imageUrl },
                        // <!-- Twitter Meta Tags -->
                        { "name": "twitter:card", "content": "summary_large_image" },
                        { "name": "twitter:title", "content": this.state.initialData && this.state.initialData['title'] ? this.state.initialData['title'] : "PARENTING.FIRSTCRY.COM" },
                        { "name": "twitter:description", "content":  this.state.initialData && this.state.initialData['description'] ? this.state.initialData['description'] : this.state.metaDescription },
                        { "name": "twitter:image", "content": this.state.imageUrl }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a className="R11_9e" href="/">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href="/baby-photo-contest">Memories Contest</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>{this.state.initialData && this.state.initialData['title']!='' ? this.state.initialData['title'] : ''}</span>
                    </div>
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>{this.state.initialData && this.state.initialData['title']!='' ? this.state.initialData['title'] : ''}</h1>
                </div>
                <div className="sub-container memoriesContest-cnt left">
                    <div className="data-container left">
                        {this.state.initialData ? 
                        <div>
                        {this.state.initialData  && this.state.initialData.map((result, index) =>
                        <div className="container_bump">
                            <div className="contestDet-cnt" key = {index}>
                                <div className="con_details_block">
                                    <div className="contest-content">
                                        <div className="contest-banner">
                                            <img src={result.banners[0].bannerUrl.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")} onError={(e) => (e.target.src = result.banners[0].bannerUrl.replace("http://", "https://"))} alt="image" title="image"/> 
                                            { result.isActive ==1 && result.showMsg ?
                                            <div className="hurry-up det-hurryup">
                                                <span className="M12_white">{result.showMsg.length > 20 ? result.showMsg.substring(0,20): result.showMsg}</span>
                                            </div> : ''
                                            } 
                                        </div>
                                        <span className="contestDet-nam M18_42" id="cont-nm">
                                        {result.title ? result.title : ''}
                                        </span>
                                        <div className="contest-share right" onClick={() => actions.shareOn(result.contestId)}  id={`share_${result.contestId}`}>
                                            <span className="share-ic fb-icon left">
                                                <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook-icon.png'}
                                                alt="Facebook" title="Facebook" />
                                            </span>
                                            <span data-icon-font="" className="share-ic whtap-icon left"></span>
                                            <span className="M13_61 left">Share</span>
                                            <div className="sharing-options">
                                                <ul className="left">
                                                    <li className="whatsapp-share left" 
                                                        onClick={() => actions.shareArticle(global.redirect_url+'baby-photo-contest/contest/'+actions.loadcontestName(result.title)+'/'+result.contestId, 'whatsapp', result.banners[0].bannerUrl,actions.loadcontestName(result.title))}>
                                                    <span className="M16_61 social-share" id="whatsapp">
                                                        <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png'} className="fetusfacebookimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                                                    </span>
                                                    </li>
                                                    <li className="facebook-share left" onClick={() => actions.shareArticle(global.redirect_url+'baby-photo-contest/contest/'+actions.loadcontestName(result.title)+'/'+result.contestId, 'facebook', result.banners[0].bannerUrl,actions.loadcontestName(result.title))}>
                                                    <span className="M16_61 social-share" id="facebook">
                                                        <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png'}className="facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                                                    </span>
                                                    </li>
                                                    <li className="twitter-share left" onClick={() => actions.shareArticle(global.redirect_url+'baby-photo-contest/contest/'+actions.loadcontestName(result.title)+'/'+result.contestId, 'twitter', result.banners[0].bannerUrl,actions.loadcontestName(result.title))}>
                                                    <span className="M16_61 social-share" id="twitter">
                                                        <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png'} className="twitterimg"  alt="Twitter Icon" title="Twitter Icon" />
                                                    </span>
                                                    </li>
                                                    <li className="twitter-share left" onClick={() => actions.shareArticle(global.redirect_url+'baby-photo-contest/contest/'+actions.loadcontestName(result.title)+'/'+result.contestId, 'pintrest', result.banners[0].bannerUrl,actions.loadcontestName(result.title))}>
                                                    <span className="M16_61 social-share" id="pintrest">
                                                        <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png'} className= "pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                                                    </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        
                                        { result.isActive == 1 ?
                                        <div className="inprogress R13_green">
                                            <span className="dot"></span>In Progress
                                        </div>
                                        :
                                        <div className="closed R13_red" style={{display:'block'}}>
                                            Closed
                                        </div>
                                        }
                                        <p className="contest-descp R15_61" id="cont-descp">{result.description ? result.description : ''}</p>
                                        <div className="cont-period prd-rslt">
                                            <span className="period-text fl R15_9e">Contest Period :</span>
                                            <span className="fl R14_42" id="cont-date">{ result.startDate ? actions.formatArticleDate(result.startDate) : ''} - {result.endDate ? actions.formatArticleDate(result.endDate): ''}</span>
                                        </div>
                                        <div className="result-date prd-rslt" id="rslt-date">
                                            <span className="results fl R15_9e">Result Date :</span>
                                            <span className="R14_42 devresdate" id="result-dt">{ result.resultDate ? actions.formatArticleDate(result.resultDate) : ''}</span>
                                        </div>
                                        { result.isResultDeclared == 0 && result.isActive == 0 ?
                                        <div className="vote-close R15_red">
                                            <span className="icon status_icon" data-icon-font="d"></span>
                                            <span className="moderate_status_text">Voting and Participation for this contest is over. Do visit this page soon to know Winners of the Contest!</span>
                                        </div>
                                        : null
                                        }
                                        {  result.isActive && result.isActive == 1 ?   
                                        
                                        <div className="landing-btn cont-btns devdetailupldphto" id="upload-img" onClick={() => actions.goToFeature(result.contestTypeData, result.contestId)}>
                                        {result.contestTypeData == "Milestone Contest" || result.contestTypeData == "Face a day" || result.contestTypeData == "My Bumpie" || result.contestTypeData == "Memories Contest" ?
                                            <span data-icon-font="&#xe000;" className="icon uploadPhoto_icon devdetailupldphto" id={result.contestId}></span>
                                        : ''}
                                        { 
                                            result.contestTypeData == "Milestone Contest" || result.contestTypeData == "Face a day" || result.contestTypeData == "My Bumpie" || result.contestTypeData == "Memories Contest" 
                                            ?
                                            <span className="M14_white devuploadphoto" id={result.contestId} >UPLOAD NOW</span> 
                                            : 
                                            result.contestTypeData == "Discussion" || result.contestTypeData == "Read" ? <span className="M14_white devuploadphoto" id={result.contestId} >PARTICIPATE NOW</span>
                                            :
                                            result.contestTypeData == "Q and A" ? <span className="M14_white devuploadphoto" id={result.contestId} >ASK NOW</span>
                                            :
                                            result.contestTypeData == "Vaccination" || result.contestTypeData == "Baby Teething Tool" ? <span className="M14_white devuploadphoto" id={result.contestId} >UPDATE TRACKER</span>
                                            :
                                            result.contestTypeData == "Groups" ? <span className="M14_white devuploadphoto" id={result.contestId} >UPDATE TRACKER</span>
                                            :
                                            <span className="M14_white devuploadphoto" id={result.contestId} >UPLOAD NOW</span> 
                                        }
                                        </div>
                                        : null
                                        }
                                        <div className="past-participant-wrapper">
                                        {result.participate && result.participate.length > 0 && result.participate.map((participants, index) =>
                                            <div>
                                            {participants.isLoginParticipate ?
                                            <div className="past-participant-details loggedinuser">
                                                <div className="past-first-det-blc">
                                                    <a className="past-parti-img left" href={`/memories/photodetails/${participants.memoryid}`}>
                                                        <img src={participants.imageUrl.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")} onError={(e) => (e.target.src = participants.imageUrl.replace("http://", "https://"))} />
                                                    </a>
                                                    <div className="past-parti-info left">
                                                        <a className="past-parti-det" href="">
                                                            <div className="past-parti-name M18_42">
                                                            {participants.userName}
                                                            </div>
                                                        </a>
                                                        <div className="past-parti-rank M16_9e"> Rank : {participants.rank} </div>
                                                    </div>
                                                </div>
                                                <ul className="past-parti-contest-det">
                                                    <li>
                                                        <div className="R15_9e past-nm">Likes</div>
                                                        <div className="past-contestlk-count M18_42">{participants.likeCount}</div>
                                                    </li>
                                                    <li>
                                                        <div className="R15_9e past-nm">Comments</div>
                                                        <div className="past-contestlk-count M18_42">{participants.commentCount}</div>
                                                    </li>
                                                </ul>
                                            </div>
                                            :
                                            <div className="past-participant-details">
                                                <div className="past-first-det-blc">
                                                    <a className="past-parti-img left" href={`/memories/photodetails/${participants.memoryid}`}>
                                                        <img src={participants.imageUrl.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")} onError={(e) => (e.target.src = participants.imageUrl.replace("http://", "https://"))} />
                                                    </a>
                                                    <div className="past-parti-info left">
                                                        <a className="past-parti-det" href="">
                                                            <div className="past-parti-name M18_42">
                                                            {participants.userName}
                                                            </div>
                                                        </a>
                                                        <div className="past-parti-rank M16_9e"> Rank : {participants.rank} </div>
                                                    </div>
                                                </div>
                                                <ul className="past-parti-contest-det">
                                                    <li>
                                                        <div className="R15_9e past-nm">Likes</div>
                                                        <div className="past-contestlk-count M18_42">{participants.likeCount}</div>
                                                    </li>
                                                    <li>
                                                        <div className="R15_9e past-nm">Comments</div>
                                                        <div className="past-contestlk-count M18_42">{participants.commentCount}</div>
                                                    </li>
                                                </ul>
                                            </div>
                                            }
                                            </div>
                                        )}
                                        </div>                                        
                                        <input type="hidden" name="loginuserMemId" value="" id="loginuserMemId"></input>

                                        { result.isShowLeaderboard == 1 ? 
                                        <a className="" id="entries" href={` ${global.redirect_url}baby-photo-contest/contest/${actions.loadcontestName(result.title)}/${result.isWinnerbased == 1 ? 'leaderboard' : 'entries'}/${result.contestId}`} key={result.contestId}  onClick={() => actions.networkCheck()}>

                                        <span className="M14_white" id="dev_viewLeaderBrd"> {result.isWinnerbased == 1 ? 'VIEW LEADERBOARD' : 'VIEW ENTRIES'}</span>
                                        </a>  
                                         : ''
                                        }
                                    </div>
                                </div>
                                { result.winners && result.winners.length > 0?
                                <div className="cute-winners">
                                    <div className="cutewinners-title M18_42">
                                        <span className="ourwinners M18_42">Our Cute Winners</span>
                                        <div className="border-line"></div>
                                    </div>
                                    <div className="parenting-slider2 tmp_5">
                                        { result.winners.length > 0 ?
                                        <div> 
                                            <ul className="slider temp5 fl" data-count={result.winners.length} style={{ width: '1090px' }}>
                                                { result.winners.length > 0 && result.winners.length <= 3 ? 
                                                result.winner && result.winners.length > 0 && result.winners.map((winner, index) =>
                                                <li className="slide template5 fl">
                                                    <a href={`/memories/photodetails/${winner.id}`} target="_blank" title={winner.userName}  onClick={() => actions.networkCheck()}>
                                                        <img className="dsblk" src={winner.image_url.replace("http://", "https://").replace(/\.(png|jpg|jpeg)$/i, ".webp")} onError={(e) => (e.target.src = winner.image_url.replace("http://", "https://"))} title="Bottom Wear"  alt="Bottom Wear" />
                                                    </a>
                                                    <div id="winner-nm" className="winner-name M14_42">{winner.userName}</div>
                                                    <div className="prize-won R14_9e">{winner.description ? winner.description : ''}</div>
                                                    <div className="winnertag">
                                                        <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/contest-winner-icon.svg'} alt="winner" title="winner" />
                                                    </div>
                                                </li>
                                                )
                                                :
                                                <li className="allbtn-slide slide template5 fl">
                                                    <a href={`/baby-photo-contest/contest/${actions.loadcontestName(result.title)}/winners/${result.contestId}`} title={result.title} className="viewallwinners" id={result.title}  onClick={() => actions.networkCheck()}>
                                                        <div className="arrow_container">
                                                            <span className="all-icon viewallwinnersicon" id={result.title} data-icon-font="&"></span>
                                                        </div>
                                                        <span className="R14_pink viewallwinnerstxt" id={result.title}>View All Winners</span>
                                                    </a>
                                                </li>
                                                }
                                            </ul> 
                                            <div className="arrows">                    
                                                <span className="next" >
                                                    <span data-icon-font="h" className="icon"></span>
                                                </span>                    
                                                <span className="prev" >
                                                    <span data-icon-font="g" className="icon"></span>
                                                </span>                      
                                            </div>
                                        </div>
                                        : '' }
                                    </div>
                                </div>
                                :
                                null } 
                            
                                { result.prize.length > 0 ?
                                <div className="prize-cnt">
                                    <div className="prz-lst M15_42">
                                        <span className="prize_title M18_42">Prizes</span>
                                        <div className="border-line"></div>
                                    </div>
                                    <ul className="prizelist">
                                        { (result.isWinnerbased == 1 || result.isWinnerbased == 0) ?
                                        result.prize && result.prize.length > 0 && result.prize.map((row, index) =>
                                        <li className="prizes">
                                            <div className="prize-img">
                                                <img src={'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/tag-icon.svg'} />
                                                <span className="prize_rank">
                                                    <span className="rank_number">{row.rank}</span>
                                                    { 
                                                    row.rank == 1 ? <span className="rank_num_next">st</span>
                                                    :
                                                    row.rank == 2 ? <span className="rank_num_next">nd</span>
                                                    :
                                                    row.rank == 3 ? <span className="rank_num_next">rd</span> : ''
                                                    }
                                                </span>
                                            </div>
                                            <div className="prize M14_42">
                                                <span className="lucky-winners">{row.prize ? row.prize : ''}</span>
                                                <div className="lucky-winners" style={{color:'#e0e0e0'}}>{row.description ? row.description : ''}</div>
                                            </div>
                                        </li>
                                        )
                                        :
                                        <li className="prizes">
                                            <div className="prize M14_42">
                                                <span className="lucky-winners">{result.prize[0].prize ? result.prize[0].prize : ''}</span>
                                            </div>
                                        </li>
                                        }
                                    </ul>
                                    <div className="work-flow">
                                        <a id="how_it_works" href={`/baby-photo-contest/howItWorks/${result.contestId}`} className="M14_pink steps_title"  onClick={() => actions.networkCheck()}>                      
                                            <span id="dev_how_it_works">STEPS TO PARTICIPATE</span>
                                        </a>
                                        <a id="terms-n-cond" href={`/baby-photo-contest/termsAndConditions/${result.contestId}`} className="M14_pink steps_title"  onClick={() => actions.networkCheck()}>
                                            <span id="">TERMS AND CONDITIONS</span>
                                        </a>
                                    </div>
                                </div>
                                : null
                                }
                            </div>
                        </div>
                        )} 
                        </div> 
                        :
                        <div className="no_record"></div>
                        }
                    </div>
                </div>
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withLocation(ContestDetails);
